"use strict";
/* eslint no-param-reassign: [0] */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var lodash_1 = require("lodash");
function paramValueIsNotEqualTo(params, key, value) {
    var currentValue = params[key];
    return currentValue &&
        currentValue !== value &&
        !lodash_1.includes(currentValue, value);
}
function paramsOverriddenByNewValues(params, objectWithNewValues) {
    return tslib_1.__assign(tslib_1.__assign({}, params), objectWithNewValues);
}
function paramsWithoutKeys(params, keys, newParams) {
    if (newParams === void 0) { newParams = null; }
    newParams = newParams || (tslib_1.__assign({}, params));
    keys.forEach(function (key) { return delete newParams[key]; });
    return newParams;
}
exports.default = {
    batch: function (params, actionToParamsMap) {
        var newParams = tslib_1.__assign({}, params);
        if (actionToParamsMap.set) {
            newParams = paramsOverriddenByNewValues(params, actionToParamsMap.set);
        }
        if (actionToParamsMap.unset) {
            newParams = paramsWithoutKeys(params, actionToParamsMap.unset, newParams);
        }
        if (!lodash_1.get(actionToParamsMap, 'set.page')) {
            delete newParams.page;
        }
        return newParams;
    },
    setAll: function (params) {
        return params;
    },
    set: function (params, obj) {
        var newParams = paramsOverriddenByNewValues(params, obj);
        if (!obj.page) {
            delete newParams.page;
        }
        return newParams;
    },
    unset: function (params, keys) {
        var newParams = paramsWithoutKeys(params, keys);
        delete newParams.page;
        return newParams;
    },
    unmergeArrayParams: function (params, obj) {
        // removes a value from an array of params
        // if the set is empty, it will remove the key entirely
        //
        // params.condition == ['new', 'used']
        // handleArrayParamsUnmerge({ condition: 'new' }) => this.params.condition == ['used']
        // handleArrayParamsUnmerge({ condition: 'used' }) => this.params.condition == undefined
        var newParams = lodash_1.clone(params);
        lodash_1.each(obj, function (value, key) {
            var currentValue = newParams[key];
            var currentValueStr = (currentValue === undefined ? '' : currentValue).toString();
            var valueStr = (value === undefined ? '' : value).toString();
            if (lodash_1.isArray(currentValue)) {
                newParams[key] = lodash_1.without(currentValue, value);
            }
            else if (currentValueStr === valueStr) {
                delete newParams[key];
            }
        });
        delete newParams.page;
        return newParams;
    },
    mergeArrayParams: function (params, obj) {
        // if param does not already exist, will add it to params
        // if param already has a value, will convert query param to array
        //
        // params.condition == undefined
        // handleArrayParamsMerge({ foo: 'bar' }) => this.params.foo == 'bar'
        // handleArrayParamsMerge({ foo: 'buz' }) => this.params.foo == ['bar', 'buz']
        var newParams = lodash_1.clone(params);
        lodash_1.each(obj, function (value, key) {
            if (paramValueIsNotEqualTo(params, key, value)) {
                var currentValue = newParams[key];
                if (!lodash_1.isArray(currentValue)) {
                    currentValue = [currentValue];
                }
                newParams[key] = currentValue.concat(value);
            }
            else {
                newParams[key] = value;
            }
        });
        delete newParams.page;
        return newParams;
    },
};
//# sourceMappingURL=params_builder.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/dist/components/discovery/params_builder.js
// module id = 2BZL
// module chunks = 20 21